import { ScalarUUID } from 'hasura';

/** Категория наград */
export interface IClsCategoryAward {
  id: ScalarUUID;
  /** Название */
  name: string;
  /** Код */
  code: string | null;
  /** Дата создания */
  time_create: string;
  /** Признак удаления */
  is_deleted: boolean;
}

export enum ECategoryAward {
  STATE = 'state',
  REGIONAL = 'regional',
  ENCOURAGEMENT = 'encouragement',
}

export const CATEGORY_AWARD = {
  STATE: 'Государственные награды РФ',
  REGIONAL: 'Государственные награды РБ',
  ENCOURAGEMENT: 'Меры поощрений',
} as const;
